import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { Accordion } from "PFComponents/accordion";
import { Inline } from "PFComponents/containers";
import { TooltipIcon } from "PFComponents/tooltip";
import { useMatchableTypes } from "PFCore/helpers/activities";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { AccessLevel } from "PFTypes";
import { useTranslation } from "react-i18next";

import { MatchAttributeSection } from "./match_attribute_section";
import css from "./match_attributes.module.scss";

export const MatchAttributes = () => {
  const { t } = useTranslation("activities", { keyPrefix: "matchAttributes" });
  const activity = useCurrentActivity();
  const { getCustomTypeByName } = useCustomTypes();

  const matchableTypes = useMatchableTypes({
    templateId: activity.template_id,
    levels: [AccessLevel.ReadWrite, AccessLevel.ReadOnly],
    activityCreator: activity.profile
  });

  const isOwner = activity.coowned;

  const renderHeader = () => (
    <Inline as="span" alignItems="center" spread>
      {t("title")}
      {isOwner && (
        <TooltipIcon
          content={t("disclaimer")}
          tooltipProps={{
            tooltipContainerProps: { style: { maxWidth: 360 } },
            triggerContainerProps: { as: "span" }
          }}
        />
      )}
    </Inline>
  );

  return (
    <>
      <Accordion
        header={renderHeader()}
        defaultState="closed"
        headerVariant="bodyBold"
        headerFullWidth
        iconSet="chevron"
        qaId="MatchAttributesAccordion"
      >
        <div className={css.root}>
          {matchableTypes.map((matchableType) => {
            const customType = getCustomTypeByName(matchableType.name);

            if (!customType) {
              return null;
            }
            return (
              <MatchAttributeSection
                key={matchableType.name}
                matchableType={matchableType}
                customType={customType}
              />
            );
          })}
        </div>
      </Accordion>
    </>
  );
};
